<div class="flex flex-col gap-1 m-3">
    <span class="text-base">{{ title() }}</span>
    <div class="overflow-x-auto table-max-height">
        <app-custom-table [columns]="columns()">
            @for (id of Object.keys(layerInfo()); track id) {
                <tr>
                    @if (
                        layerType() === AddLayerSelectionType.TABLE ||
                        layerType() === AddLayerSelectionType.REFERENCE_DATA
                    ) {
                        <td>{{ layerInfo()[id].tableName }}</td>
                        <td>{{ addLayerService.selectedDepositVersionAndName() }}</td>
                        <td>
                            <fa-icon
                                class="cursor-pointer"
                                size="lg"
                                [icon]="[
                                    'fas',
                                    addLayerService.layerFormRecord!.controls[id].value.versionLock
                                        ? 'lock'
                                        : 'lock-open',
                                ]"
                                (click)="addLayerService.updateCurrentLayerLock(id)" />
                        </td>
                    } @else if (isInterstandardFolderSelected()) {
                        <td>{{ addLayerService.selectedFirstInterstandardDepositFolder()!.name }}</td>
                        <td>{{ addLayerService.selectedSecondInterstandardDepositFolder()!.name }}</td>
                    }
                    <td>
                        <app-input-text
                            class="input-background-color"
                            [errors]="!addLayerService.layerFormRecord!.controls[id].value.name ? ['error'] : []"
                            [inputFormControl]="addLayerService.layerFormRecord!.controls[id].controls.name"
                            [placeholder]="addLayerService.layerFormRecord!.controls[id].value.name" />
                    </td>
                    @if (hasGeomProperty()) {
                        <td class="align-middle">
                            <div class="flex justify-center items-center h-full">
                                <fa-icon
                                    [icon]="[
                                        'fas',
                                        addLayerService.layerFormRecord!.controls[id].value.isVisible
                                            ? 'eye'
                                            : 'eye-slash',
                                    ]"
                                    (click)="addLayerService.updateCurrentLayerVisibility(id)" />
                            </div>
                        </td>
                        <td>
                            <mat-form-field
                                appearance="outline"
                                class="w-20"
                                subscriptSizing="dynamic">
                                <input
                                    class="!bg-white !py-2 !pl-3"
                                    matInput
                                    min="0"
                                    step="1"
                                    type="number"
                                    [formControl]="addLayerService.layerFormRecord!.controls[id].controls.order" />
                            </mat-form-field>
                        </td>
                    }
                    @if (shouldDisplayFieldInterventionContextColumn()) {
                        <td class="align-middle">
                            <div class="flex justify-center items-center h-full">
                                @if (getFieldInterventionContextConfig(id); as contextConfig) {
                                    <app-field-intervention-context-icon
                                        size="lg"
                                        [config]="contextConfig"
                                        (contextClick)="
                                            addLayerService.toggleFieldInterventionContext(
                                                id,
                                                canManageFieldInterventionContextSelection()
                                            )
                                        " />
                                }
                            </div>
                        </td>
                    }
                    <td>
                        @if (layerType() === AddLayerSelectionType.TABLE) {
                            <app-add-layer-business-identifier
                                [currentBusinessIdentifierValue]="
                                    addLayerService.layerFormRecord!.controls[id].value.businessIdentifier ?? null
                                "
                                [layer]="layerInfo()[id]"
                                (columnSelection)="addLayerService.updateCurrentLayerBusinessIdentifier($event, id)" />
                        } @else if (layerType() === AddLayerSelectionType.INTERSTANDARD) {
                            {{ layerInfo()[id].businessIdentifier }}
                        }
                    </td>
                </tr>
            }
        </app-custom-table>
    </div>
</div>
